export default "__VITE_ASSET__fn7BBmqh__"